import {GuidingTourActions} from './types';
import {buildAsyncActionsCreator, createAsyncActionExecutor} from '../asyncUtils';
import {requestHasViewedGuidedTour} from './api';

export const guidingTourLoadDetailActionsCreator = buildAsyncActionsCreator(GuidingTourActions.FETCH_DETAIL);
export const guidingTourLoadDetail = createAsyncActionExecutor(
  guidingTourLoadDetailActionsCreator,
  requestHasViewedGuidedTour,
);
